<template>
  <div>
    <section class="section bg-gray">
      <div class="container">
        <div class="row gap-y align-items-center">
          <div class="col-md-4">
            <p class="lead-7 text-dark fw-600 lh-2">Clear And Simple Pricing</p>
            <div class="btn-group btn-group-toggle my-7">
              <label
                :class="
                  mainPriceType === 'perpetual'
                    ? 'btn btn-round btn-outline-dark w-150 active'
                    : 'btn btn-round btn-outline-dark w-150'
                "
              >
                <input type="radio" value="perpetual" v-model="mainPriceType" />
                Perpetual
              </label>
              <label
                :class="
                  mainPriceType === 'subscription'
                    ? 'btn btn-round btn-outline-dark w-150 active'
                    : 'btn btn-round btn-outline-dark w-150'
                "
              >
                <input type="radio" value="subscription" v-model="mainPriceType" />
                Subscription
              </label>
            </div>
            <p class="lead">
              Our prices are very easy to understand. There's not any extra or hidden fee. You just
              pay what is listed here.
            </p>
          </div>
          <div class="col-md-7 ml-auto">
            <div class="row gap-y">
              <div class="col-md-6">
                <div class="card text-center shadow-1 hover-shadow-9">
                  <div
                    class="card-img-top text-white bg-img h-200 d-flex align-items-center"
                    :style="{ 'background-image': `url('${standardImg}')` }"
                    data-overlay="1"
                  >
                    <div class="position-relative w-100">
                      <p class="lead-4 fw-600 ls-1 mb-0">Standard</p>
                      <p v-if="mainPriceType === 'outside'">
                        <span data-bind-radio="pricing" data-monthly="Monthly" data-yearly="Yearly"
                          >Monthly</span
                        >
                        Package
                      </p>
                    </div>
                  </div>
                  <div class="card-body py-6">
                    <p class="lead-7 fw-600 text-dark mb-0">
                      <span v-if="mainPriceType === 'perpetual'">₹16000</span>
                      <span v-else>₹1500</span>
                    </p>
                    <p class="text-lighter" v-if="mainPriceType === 'outside'">/ user / month</p>
                    <p v-if="mainPriceType === 'perpetual'">
                      <strong>Perpetual</strong> <br />
                      Supports only one device <br />
                      Desktop only app <br />
                      Plus 18% GST <br />
                      20% Annual Maintenance Charges<br />
                    </p>
                    <p v-else>
                      <strong>Monthly Pricing</strong> <br />
                      Supports only one device <br />
                      Desktop only app <br />
                      Plus 18% GST <br />
                    </p>
                  </div>
                </div>
              </div>

              <div class="col-md-6">
                <div class="card text-center shadow-1 hover-shadow-9">
                  <div
                    class="card-img-top text-white bg-img h-200 d-flex align-items-center"
                    :style="{ 'background-image': `url('${advanceImg}')` }"
                    data-overlay="2"
                  >
                    <div class="position-relative w-100">
                      <p class="lead-4 fw-600 ls-1 mb-0">Advanced</p>
                    </div>
                  </div>
                  <div class="card-body py-6">
                    <p class="lead-7 fw-600 text-dark mb-0">
                      <span v-if="mainPriceType === 'perpetual'">₹30000</span>
                      <span v-else>₹3000</span>
                    </p>

                    <p v-if="mainPriceType === 'perpetual'">
                      <strong>Perpetual</strong> <br />
                      Supports Multi Devices (Upto 3) <br />
                      Free android app <br />

                      Plus 18% GST <br />

                      20% Annual Maintenance Charges<br />
                    </p>
                    <p v-else>
                      <strong>Monthly Pricing</strong> <br />
                      Supports Multi Devices (Upto 3) <br />
                      Free android app <br />

                      Plus 18% GST <br />
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import standardImg from '../assets/img/preview/dribbble-3.jpg';
import advanceImg from '../assets/img/preview/dribbble-11.jpg';

export default {
  data: () => ({
    standardImg,
    advanceImg,
    mainPriceType: 'perpetual',
  }),
};
</script>
